module.exports = __webpack_public_path__ + "img/little-house-with-keys.4fec929f.jpg";